import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DashboardPage from './pages/DashboardPage';
import SessionDetailPage from './pages/SessionDetailPage';

function App() {
  return (
    <Router>
      <div className="bg-gray-100 min-h-screen">
        <header className="bg-white shadow">
          <nav className="container mx-auto px-6 py-3">
            <h1 className="text-2xl font-bold text-gray-800">
              <a href="/">Message Buffer Dashboard</a>
            </h1>
          </nav>
        </header>
        <main className="container mx-auto px-6 py-8">
          <Routes>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/session/:id" element={<SessionDetailPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
